import { BRL, Chave, Dinheiro, MODULOS, Numero, Pilula, SEGMENTOS, Secao } from "./comum";

const alternar = (lista, item) => (lista.includes(item) ? lista.filter((x) => x !== item) : [...lista, item]);

export function QuemGanha({ cfg, mudar, ticketMedio, porSegmento = {} }) {
  const sugestao = ticketMedio ? Math.max(5, Math.round((ticketMedio * 0.6) / 5) * 5) : null;
  const segs = cfg.segmentos || [];
  const totalClientes = Object.values(porSegmento).reduce((s, n) => s + Number(n || 0), 0);
  const qtd = (n) => Number(n || 0).toLocaleString("pt-BR");
  return (
    <Secao numero={2} titulo="Quem ganha carimbo" descricao="Um carimbo por compra. Só cliente identificado (com telefone) ganha.">
      <div className="py-2.5 border-b">
        <div className="flex flex-wrap items-center justify-between gap-3">
          <span className="text-sm">
            <span className="font-medium">Valor mínimo do pedido</span>
            <span className="block text-xs text-muted-foreground mt-0.5">Sem frete. R$ 0,00: qualquer valor. Um mínimo bom também evita dividir uma compra em várias pequenas.</span>
          </span>
          <Dinheiro valor={cfg.valor_minimo || 0} onChange={(v) => mudar({ valor_minimo: v || 0 })} e2e="valor-minimo" />
        </div>
        {sugestao && (
          <button type="button" onClick={() => mudar({ valor_minimo: sugestao })} className="mt-1.5 text-xs text-primary hover:underline">
            Sugestão: {BRL(sugestao)} (60% do seu ticket médio de {BRL(ticketMedio)})
          </button>
        )}
      </div>
      <Chave rotulo="Pedido com cupom também ganha carimbo" ajuda="O cartão premia quem volta, e muitas vezes é o cupom que traz o cliente."
        marcado={cfg.cupom_ganha} onChange={(v) => mudar({ cupom_ganha: v })} />
      <div className="py-2.5 border-b">
        <p className="text-sm font-medium">Onde o cartão vale</p>
        <p className="text-xs text-muted-foreground mt-0.5 mb-2">Nos canais marcados o cliente ganha carimbo, vê o cartão e usa o prêmio.</p>
        <div className="flex flex-wrap gap-2">
          {Object.entries(MODULOS).map(([k, v]) => (
            <Pilula key={k} ativo={(cfg.modulos || []).includes(k)} onClick={() => mudar({ modulos: alternar(cfg.modulos || [], k) })}
              e2e={`canal-${k}`}>{v}</Pilula>
          ))}
        </div>
      </div>
      <div className="pt-2.5">
        <p className="text-sm font-medium">Para quais clientes</p>
        <p className="text-xs text-muted-foreground mt-0.5 mb-2">
          Os mesmos tipos da tela de Clientes. O tipo é conferido quando o cartão abre; depois o cliente segue até completar.
        </p>
        <div className="flex flex-wrap gap-2">
          <Pilula ativo={!segs.length} onClick={() => mudar({ segmentos: [] })} e2e="segmento-todos">
            Todos os clientes{totalClientes ? <span className="ml-1.5 opacity-75 tabular-nums">{qtd(totalClientes)}</span> : null}
          </Pilula>
          {Object.entries(SEGMENTOS).map(([k, [nome, regra]]) => (
            <span key={k} title={regra}>
              <Pilula ativo={segs.includes(k)} onClick={() => mudar({ segmentos: alternar(segs, k) })} e2e={`segmento-${k}`}>
                {nome}<span className="ml-1.5 opacity-75 tabular-nums">{qtd(porSegmento[k])}</span>
              </Pilula>
            </span>
          ))}
        </div>
        {!!segs.length && (
          <p className="text-xs text-muted-foreground mt-2">
            <b className="text-foreground">{qtd(segs.reduce((s, k) => s + Number(porSegmento[k] || 0), 0))} clientes</b> hoje nesses tipos · {segs.map((k) => `${SEGMENTOS[k][0]}: ${SEGMENTOS[k][1]}`).join(" · ")}
          </p>
        )}
      </div>
    </Secao>
  );
}

export function ValidadeECombinacoes({ cfg, mudar }) {
  return (
    <Secao numero={3} titulo="Validade e combinações">
      <div className="flex flex-wrap items-center justify-between gap-3 py-2.5 border-b">
        <span className="text-sm"><span className="font-medium">O prêmio vale por</span>
          <span className="block text-xs text-muted-foreground mt-0.5">Contados de quando ele é liberado.</span></span>
        <Numero valor={cfg.validade_dias} onChange={(v) => mudar({ validade_dias: v })} sufixo="dias" min={1} max={365} largura="w-16" />
      </div>
      <div className="flex flex-wrap items-center justify-between gap-3 py-2.5 border-b">
        <span className="text-sm"><span className="font-medium">O cartão zera depois de</span>
          <span className="block text-xs text-muted-foreground mt-0.5">Sem comprar nesse tempo, volta para 2/10 (o prêmio continua o mesmo). Zero: nunca zera.</span></span>
        <Numero valor={cfg.zerar_dias} onChange={(v) => mudar({ zerar_dias: v })} sufixo="dias sem compra" min={0} max={730} largura="w-16" />
      </div>
      <Chave rotulo="O pedido que usa o prêmio já ganha carimbo" ajuda="Emenda um cartão no outro: o prêmio já começa o próximo."
        marcado={cfg.premio_ganha_carimbo} onChange={(v) => mudar({ premio_ganha_carimbo: v })} />
      <Chave rotulo="Produto grátis só junto com outro item pago" ajuda="Evita pedido de entrega só com o brinde."
        marcado={cfg.gratis_exige_item_pago} onChange={(v) => mudar({ gratis_exige_item_pago: v })} />
      <Chave rotulo="O prêmio soma com o cashback" ajuda="No mesmo pedido o cliente usa o prêmio e o saldo do cashback."
        marcado={cfg.soma_cashback} onChange={(v) => mudar({ soma_cashback: v })} />
      <p className="text-xs text-muted-foreground pt-2.5">
        O prêmio chega ao cliente como um cupom guardado na conta dele, por isso não soma com outro cupom no mesmo pedido.
      </p>
    </Secao>
  );
}

export function Avisos({ cfg, mudar }) {
  const wa = cfg.whatsapp || {};
  const m = (k) => (v) => mudar({ whatsapp: { ...wa, [k]: v } });
  return (
    <Secao numero={4} titulo="Avisos no WhatsApp" descricao="Saem pelo WhatsApp da loja, só para quem já conversou com ela (a mesma regra dos outros avisos automáticos).">
      <Chave rotulo="Foto do cartão a cada carimbo" ajuda="Quando o pedido é concluído: o cartão atualizado e quanto falta." marcado={wa.foto} onChange={m("foto")} />
      <Chave rotulo="Aviso de prêmio liberado" ajuda="O cartão completo e como usar o prêmio." marcado={wa.premio} onChange={m("premio")} />
    </Secao>
  );
}
